import { RouteObject } from 'react-router-dom';
import SegmentConnectCheckout from '~aqarConnect/pages/SegmentConnectCheckout';
import ProposalConfirm from '~aqarConnect/pages/ProposalConfirm';
import RequireAuth from '~/components/auth/RequireAuth';
import AuthLayout from '~/components/auth/AuthLayout';

const routes: RouteObject[] = [
  { path: 'proposal/:id/confirm', element: <ProposalConfirm /> },
  {
    path: 'segment/:id/checkout',
    element: (
      <RequireAuth>
        <AuthLayout />
      </RequireAuth>
    ),
    children: [{ index: true, element: <SegmentConnectCheckout /> }],
  },
];

export default routes;
